// Import auth utilities
import { checkResponseStatus } from '../utils/authUtils';

// Helper function to get token
const getAuthToken = () => {
    const token = localStorage.getItem('access_token') || sessionStorage.getItem('access_token');
    console.log('Retrieved token:', token ? 'Token exists' : 'No token found');
    return token;
};

// Fetch all groups
export async function fetchGroups(page = 1, limit = 16) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();

    const headers = {
        'Content-Type': 'application/json',
    };

    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    console.log('Making fetch groups request to:', `${API_BASE_URL}api/v1/dashboard/group`);

    const response = await fetch(`${API_BASE_URL}api/v1/dashboard/group?page=${page}&limit=${limit}`, {
        method: 'GET',
        headers,
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to fetch groups';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

// Create a new group
export async function createGroup(groupData) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();

    const headers = {
        'Content-Type': 'application/json',
    };

    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    console.log('Making create group request to:', `${API_BASE_URL}api/v1/dashboard/group/create`);
    console.log('Group data:', groupData);

    const response = await fetch(`${API_BASE_URL}api/v1/dashboard/group/create`, {
        method: 'POST',
        headers,
        body: JSON.stringify(groupData),
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to create group';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

// Update a group
export async function updateGroup(groupId, groupData) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();

    const headers = {
        'Content-Type': 'application/json',
    };

    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    console.log('Making update group request to:', `${API_BASE_URL}api/v1/dashboard/group/update/${groupId}`);
    console.log('Group data:', groupData);

    const response = await fetch(`${API_BASE_URL}api/v1/dashboard/group/update/${groupId}`, {
        method: 'PATCH',
        headers,
        body: JSON.stringify(groupData),
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to update group';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}

// Delete a group
export async function deleteGroup(groupId) {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    if (!API_BASE_URL) {
        throw new Error('REACT_APP_API_BASE_URL environment variable is not set');
    }

    const accessToken = getAuthToken();

    const headers = {
        'Content-Type': 'application/json',
    };

    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
        headers['Cookie'] = `jwt=${accessToken}`;
    }

    console.log('Making delete group request to:', `${API_BASE_URL}api/v1/dashboard/group/delete/${groupId}`);

    const response = await fetch(`${API_BASE_URL}api/v1/dashboard/group/delete/${groupId}`, {
        method: 'DELETE',
        headers,
    });

    checkResponseStatus(response);

    if (!response.ok) {
        let errorMessage = 'Failed to delete group';
        try {
            const errorData = await response.json();
            errorMessage = errorData.message || errorMessage;
        } catch (e) {
            errorMessage = `Server error: ${response.status} ${response.statusText}`;
        }
        throw new Error(errorMessage);
    }

    return response.json();
}